import React from 'react';
import cx from 'classnames';
import { isStore } from '../../utils/functions';
import { Icon } from '../Icons';

interface Props {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  dataValue?: string | any;
}
export const ShareAndLike = ({ onClick, dataValue }: Props) => {
  const gtmClass = isStore() ? 'gtmShareStore' : 'gtmShareAd';
  // const [like, setLike] = useState();

  // const likeClick = () => {
  //   setLike(!like);
  // };
  // const iconLike = like ? 'SvgIconHeartfull' : 'SvgIconHeart';
  return (
    <>
      <button
        onClick={onClick}
        // tslint:disable-next-line: jsx-no-multiline-js
        className={cx(
          'pointer flex justify-center items-center br3  bg-white abbey bn fw6 f16 pv12 pl12 pr16 mr12',
          gtmClass,
        )}
        title="Compartilhar"
        aria-label="Compartilhar"
        data-value={dataValue}
      >
        <Icon
          name="SvgIconShare"
          className={cx('mr8', gtmClass)}
          height={24}
          width={24}
          customId="like"
          dataValue={dataValue}
        />
        Compartilhar
      </button>
      {
        // tslint:disable-next-line: jsx-no-multiline-js
        /* <button
        onClick={likeClick}
        className="flex justify-center items-center br3  bg-white abbey bn fw6 f16 pa12 pointer"
        title="Gostar"
        aria-label="Gostar"
      >
        <Icon customId="like" name={iconLike} height={24} width={24} />
      </button> */
      }
    </>
  );
};
